import { IconButton, Menu, MenuItem, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Paper from '@material-ui/core/Paper';
import Slider from '@material-ui/core/Slider';
import Switch from '@material-ui/core/Switch';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import MenuIcon from '@material-ui/icons/Menu';
import TranslateIcon from '@material-ui/icons/Translate';
import { Layout, Message } from 'element-react';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../assets/doudizhu.scss';
import { DoudizhuGameBoard } from '../../components/GameBoard';
import ManualDealDialog from '../../components/ManualDealDialog';
import CardCounter from '../../components/CardCounter';
import WinRateTrendChart from '../../components/WinRateTrendChart';
import {
    card2SuiteAndRank,
    computeHandCardsWidth,
    deepCopy,
    fullDoudizhuDeck,
    isDoudizhuBomb,
    shuffleArray,
    sortDoudizhuCards,
    translateCardData,
} from '../../utils';
import { douzeroPredict, douzeroLegal, ensureDouzeroModels } from '../../douzero/client';

let shuffledDoudizhuDeck = shuffleArray(fullDoudizhuDeck.slice());

let threeLandlordCards = shuffleArray(sortDoudizhuCards(shuffledDoudizhuDeck.slice(0, 3)));
let originalThreeLandlordCards = threeLandlordCards.slice();

const initConsiderationTime = 30000;
const considerationTimeDeduction = 1000;
const mainPlayerId = 0; // index of main player (for the sake of simplify code logic)
let playerInfo = [];

let initHands = [
    shuffledDoudizhuDeck.slice(3, 20),
    shuffledDoudizhuDeck.slice(20, 37),
    shuffledDoudizhuDeck.slice(37, 54),
];

console.log('init hands', initHands);
console.log('three landlord card', threeLandlordCards);

let gameStateTimeout = null;

let gameHistory = [];
let bombNum = 0;
let lastMoveLandlord = [];
let lastMoveLandlordDown = [];
let lastMoveLandlordUp = [];
let playedCardsLandlord = [];
let playedCardsLandlordDown = [];
let playedCardsLandlordUp = [];
let legalActions = { turn: -1, actions: [] };
let hintIdx = -1;
let gameEndDialogTitle = '';
let syncGameStatus = localStorage.getItem('LOCALE') ? 'ready' : 'localeSelection';

function PvEDoudizhuDemoView() {
    const { t, i18n } = useTranslation();
    const [apiPlayDelay, setApiPlayDelay] = useState(3000);
    const [isGameEndDialogOpen, setIsGameEndDialogOpen] = useState(false);
    const [considerationTime, setConsiderationTime] = useState(initConsiderationTime);
    const [toggleFade, setToggleFade] = useState('');
    const [gameStatus, setGameStatus] = useState(localStorage.getItem('LOCALE') ? 'ready' : 'localeSelection'); // "localeSelection", "ready", "playing", "paused", "over"
    const [gameState, setGameState] = useState({
        hands: [[], [], []],
        latestAction: [[], [], []],
        currentPlayer: null, // index of current player
        turn: 0,
    });
    const [selectedCards, setSelectedCards] = useState([]); // user selected hand card
    const [isPassDisabled, setIsPassDisabled] = useState(true);
    const [isHintDisabled, setIsHintDisabled] = useState(true);
    const [predictionRes, setPredictionRes] = useState({ prediction: [], hands: [] });
    const [hideRivalHand, setHideRivalHand] = useState(true);
    const [oraclePredict, setOraclePredict] = useState(localStorage.getItem('ORACLE_PREDICT') === '1');
    const [showCardCounter, setShowCardCounter] = useState(localStorage.getItem('CARD_COUNTER') === '1');
    const [modelsReady, setModelsReady] = useState(false);
    const [modelsLoading, setModelsLoading] = useState(false);
    const [showPlayerRecommendations, setShowPlayerRecommendations] = useState([false, false, false]);
    const [playerWinRateHistory, setPlayerWinRateHistory] = useState([[], [], []]);
    const [remainingLandlordCards, setRemainingLandlordCards] = useState([]);
    const [gameMenuAnchor, setGameMenuAnchor] = useState(null);
    const [isManualDealOpen, setIsManualDealOpen] = useState(false);
    const [locale, setLocale] = useState(localStorage.getItem('LOCALE') || 'en');
    const [statisticRows, setStatisticRows] = useState([]);
    const [previewTick, setPreviewTick] = useState(0);

    const applyReadyDealPreview = () => {
        playerInfo = [
            { id: 0, index: 0, role: 'peasant', douzeroPlayerPosition: -1 },
            { id: 1, index: 1, role: 'peasant', douzeroPlayerPosition: -1 },
            { id: 2, index: 2, role: 'peasant', douzeroPlayerPosition: -1 },
        ];
        setGameState({
            hands: initHands.map((hand) => sortDoudizhuCards(hand.slice(), true)),
            latestAction: [[], [], []],
            currentPlayer: null,
            turn: 0,
        });
        setRemainingLandlordCards(threeLandlordCards.slice());
        setPreviewTick((n) => n + 1);
    };

    const enterReadyWithPreview = () => {
        applyReadyDealPreview();
        syncGameStatus = 'ready';
        setGameStatus('ready');
    };

    useEffect(() => {
        if (gameStatus === 'ready' && localStorage.getItem('LOCALE')) {
            applyReadyDealPreview();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        let cancelled = false;
        setModelsLoading(true);
        ensureDouzeroModels()
            .then(() => {
                if (!cancelled) {
                    setModelsReady(true);
                    setModelsLoading(false);
                }
            })
            .catch((err) => {
                if (!cancelled) {
                    setModelsLoading(false);
                    Message({
                        message: err.message || 'Failed to load AI models',
                        type: 'error',
                        showClose: true,
                        duration: 0,
                    });
                }
            });
        return () => {
            cancelled = true;
        };
    }, []);
    const cardArr2DouzeroFormat = (cards) => {
        return cards
            .map((card) => {
                if (card === 'RJ') return 'D';
                if (card === 'BJ') return 'X';
                return card[1];
            })
            .join('');
    };

    const buildPredictRequestBody = (state, playerIdx, useOracle = oraclePredict) => {
        const player_position = playerInfo[playerIdx].douzeroPlayerPosition;
        const player_hand_cards = cardArr2DouzeroFormat(state.hands[playerIdx].slice().reverse());
        const num_cards_left_landlord =
            state.hands[playerInfo.find((player) => player.douzeroPlayerPosition === 0).index].length;
        const num_cards_left_landlord_down =
            state.hands[playerInfo.find((player) => player.douzeroPlayerPosition === 1).index].length;
        const num_cards_left_landlord_up =
            state.hands[playerInfo.find((player) => player.douzeroPlayerPosition === 2).index].length;
        const three_landlord_cards = cardArr2DouzeroFormat(threeLandlordCards.slice().reverse());
        const card_play_action_seq = gameHistory
            .map((cards) => cardArr2DouzeroFormat(cards))
            .join(',');
        const other_hand_cards = useOracle
            ? cardArr2DouzeroFormat(
                  sortDoudizhuCards(
                      state.hands[(playerIdx + 1) % 3].concat(state.hands[(playerIdx + 2) % 3]),
                      true,
                  ),
              )
            : '';
        const last_move_landlord = cardArr2DouzeroFormat(lastMoveLandlord.slice().reverse());
        const last_move_landlord_down = cardArr2DouzeroFormat(lastMoveLandlordDown.slice().reverse());
        const last_move_landlord_up = cardArr2DouzeroFormat(lastMoveLandlordUp.slice().reverse());
        const bomb_num = bombNum;
        const played_cards_landlord = cardArr2DouzeroFormat(playedCardsLandlord);
        const played_cards_landlord_down = cardArr2DouzeroFormat(playedCardsLandlordDown);
        const played_cards_landlord_up = cardArr2DouzeroFormat(playedCardsLandlordUp);

        return {
            player_position,
            player_hand_cards,
            num_cards_left_landlord,
            num_cards_left_landlord_down,
            num_cards_left_landlord_up,
            three_landlord_cards,
            card_play_action_seq,
            other_hand_cards,
            last_move_landlord,
            last_move_landlord_down,
            last_move_landlord_up,
            bomb_num,
            played_cards_landlord,
            played_cards_landlord_down,
            played_cards_landlord_up,
            use_oracle: useOracle ? '1' : '0',
        };
    };

    const setPredictionFromSortedResult = (sortedResult, winRates, hands) => {
        setPredictionRes({
            prediction: sortedResult.map((result) => [result[0], winRates[result[0]]]),
            hands: hands.slice(),
        });
    };

    const getBestWinRateFromPredict = (data) => {
        if (!data.result || !data.win_rates) {
            return null;
        }
        const sortedResult = Object.entries(data.result).sort((a, b) => Number(b[1]) - Number(a[1]));
        if (sortedResult.length === 0) {
            return null;
        }
        const rate = Number(data.win_rates[sortedResult[0][0]]);
        return Number.isNaN(rate) ? null : rate;
    };

    const fetchPlayerWinRate = async (state, playerIdx, useOracle = oraclePredict) => {
        if (!modelsReady) return null;
        try {
            const requestBody = buildPredictRequestBody(state, playerIdx, useOracle);
            const data = await douzeroPredict(requestBody);
            if (data.status === 0) {
                return getBestWinRateFromPredict(data);
            }
        } catch (err) {
            // ignore per-player fetch errors for trend chart
        }
        return null;
    };

    const refreshAllPlayersWinRates = async (state, turn, useOracle = oraclePredict) => {
        const rates = await Promise.all([0, 1, 2].map((playerIdx) => fetchPlayerWinRate(state, playerIdx, useOracle)));
        setPlayerWinRateHistory((prev) =>
            prev.map((history, playerIdx) => {
                const filtered = history.filter((point) => point.turn !== turn);
                const winRate = rates[playerIdx];
                if (winRate === null || winRate === undefined || Number.isNaN(Number(winRate))) {
                    return filtered;
                }
                return [...filtered, { turn, winRate: Number(winRate) }];
            }),
        );
    };

    function timeout(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    const proceedNextTurn = async (playingCard, rankOnly = true) => {
        // take played three landlord card out
        if (playerInfo[gameState.currentPlayer].role === 'landlord' && threeLandlordCards.length > 0) {
            let playingCardCopy;
            if (rankOnly) playingCardCopy = playingCard.slice();
            else
                playingCardCopy = playingCard.map((card) => {
                    const { rank } = card2SuiteAndRank(card);
                    return rank;
                });
            threeLandlordCards = threeLandlordCards.filter((card) => {
                const { rank } = card2SuiteAndRank(card);
                const idx = playingCardCopy.indexOf(rank);
                if (idx >= 0) {
                    playingCardCopy.splice(idx, 1);
                    return false;
                } else return true;
            });
            setRemainingLandlordCards(threeLandlordCards.slice());
        }

        // if next player is user, get legal actions
        if ((gameState.currentPlayer + 1) % 3 === mainPlayerId) {
            hintIdx = -1;
            const player_hand_cards = cardArr2DouzeroFormat(gameState.hands[mainPlayerId].slice().reverse());
            let rival_move = '';
            if (playingCard.length === 0) {
                rival_move = cardArr2DouzeroFormat(sortDoudizhuCards(gameHistory[gameHistory.length - 1], true));
            } else {
                rival_move = rankOnly ? playingCard.join('') : cardArr2DouzeroFormat(playingCard);
            }
            const requestBody = {
                player_hand_cards,
                rival_move,
            };
            const data = await douzeroLegal(requestBody);
            legalActions = {
                turn: gameState.turn + 1,
                actions: data.legal_action.split(','),
            };
            setIsHintDisabled(data.legal_action === '');
            setIsPassDisabled(playingCard.length === 0 && gameHistory[gameHistory.length - 1].length === 0);
        }

        // delay play for api player
        if (gameState.currentPlayer !== mainPlayerId) {
            await timeout(apiPlayDelay);
        }

        setToggleFade('fade-out');

        let newGameState = deepCopy(gameState);

        // take played card out from hand, and generate playing cards with suite
        const currentHand = newGameState.hands[gameState.currentPlayer];
        let newHand;
        let newLatestAction = [];
        if (playingCard.length === 0) {
            newHand = currentHand;
            newLatestAction = 'pass';
        } else if (rankOnly) {
            newHand = currentHand.filter((card) => {
                if (playingCard.length === 0) return true;

                const { rank } = card2SuiteAndRank(card);
                const idx = playingCard.indexOf(rank);
                if (idx >= 0) {
                    playingCard.splice(idx, 1);
                    newLatestAction.push(card);
                    return false;
                }
                return true;
            });
        } else {
            newLatestAction = playingCard.slice();
            newHand = currentHand.filter((card) => {
                if (playingCard.length === 0) return true;

                const idx = playingCard.indexOf(card);
                if (idx >= 0) {
                    playingCard.splice(idx, 1);
                    return false;
                }
                return true;
            });
        }

        // update value records for douzero
        const newHistoryRecord = sortDoudizhuCards(newLatestAction === 'pass' ? [] : newLatestAction, true);
        switch (playerInfo[gameState.currentPlayer].douzeroPlayerPosition) {
            case 0:
                lastMoveLandlord = newHistoryRecord;
                playedCardsLandlord = playedCardsLandlord.concat(newHistoryRecord);
                break;
            case 1:
                lastMoveLandlordDown = newHistoryRecord;
                playedCardsLandlordDown = playedCardsLandlordDown.concat(newHistoryRecord);
                break;
            case 2:
                lastMoveLandlordUp = newHistoryRecord;
                playedCardsLandlordUp = playedCardsLandlordUp.concat(newHistoryRecord);
                break;
            default:
                break;
        }
        gameHistory.push(newHistoryRecord);
        if (isDoudizhuBomb(newHistoryRecord)) bombNum++;

        newGameState.latestAction[gameState.currentPlayer] = newLatestAction;
        newGameState.hands[gameState.currentPlayer] = newHand;
        newGameState.currentPlayer = (newGameState.currentPlayer + 1) % 3;
        newGameState.turn++;
        if (newHand.length === 0) {
            setGameStatus('over');
            syncGameStatus = 'over';
        }
        setGameState(newGameState);
        setToggleFade('fade-in');
        setTimeout(() => {
            setToggleFade('');
        }, 200);

        if (newHand.length > 0) {
            refreshAllPlayersWinRates(newGameState, newGameState.turn);
        }

        if (gameStateTimeout) {
            clearTimeout(gameStateTimeout);
        }

        if (newHand.length === 0) {
            const winner = playerInfo[gameState.currentPlayer];
            setTimeout(() => {
                openGameStatisticsDialog(winner.role);
            }, 2000);
        } else {
            setConsiderationTime(initConsiderationTime);
            // manually trigger timer if consideration time equals initConsiderationTime
            if (initConsiderationTime === considerationTime) gameStateTimer();
        }
    };

    const requestApiPlay = async (autoPlay = true, useOracle = oraclePredict) => {
        if (!modelsReady) return;
        const playerIdx = gameState.currentPlayer;
        const requestBody = buildPredictRequestBody(gameState, playerIdx, useOracle);

        try {
            const data = await douzeroPredict(requestBody);

            if (data.status !== 0) {
                if (data.status === -1) {
                    const player_hand_cards = cardArr2DouzeroFormat(
                        gameState.hands[playerIdx].slice().reverse(),
                    );
                    let rival_move = '';
                    if (gameHistory[gameHistory.length - 1].length > 0) {
                        rival_move = cardArr2DouzeroFormat(
                            sortDoudizhuCards(gameHistory[gameHistory.length - 1], true),
                        );
                    } else if (gameHistory.length >= 2 && gameHistory[gameHistory.length - 2].length > 0) {
                        rival_move = cardArr2DouzeroFormat(
                            sortDoudizhuCards(gameHistory[gameHistory.length - 2], true),
                        );
                    }
                    const legalRequestBody = {
                        player_hand_cards,
                        rival_move,
                    };
                    const legalRes = await douzeroLegal(legalRequestBody);
                    if (legalRes.legal_action === '') {
                        if (autoPlay) {
                            proceedNextTurn([]);
                        }
                        setPredictionRes({
                            prediction: [['', t('doudizhu.only_choice')]],
                            hands: gameState.hands[playerIdx].slice(),
                        });
                    } else if (legalRes.legal_action.split(',').length === 1) {
                        if (autoPlay) {
                            proceedNextTurn(legalRes.legal_action.split(''));
                        }
                        setPredictionRes({
                            prediction: [[legalRes.legal_action, t('doudizhu.only_choice')]],
                            hands: gameState.hands[playerIdx].slice(),
                        });
                    } else {
                        Message({
                            message: 'Error receiving prediction result, please try refresh the page',
                            type: 'error',
                            showClose: true,
                        });
                    }
                } else {
                    Message({
                        message: `Error: ${data.message}`,
                        type: 'error',
                        showClose: true,
                    });
                }
            } else {
                let bestAction = '';
                if (data.result && Object.keys(data.result).length > 0) {
                    const sortedResult = Object.entries(data.result).sort((a, b) => {
                        return Number(b[1]) - Number(a[1]);
                    });
                    setPredictionFromSortedResult(
                        sortedResult,
                        data.win_rates,
                        gameState.hands[playerIdx],
                    );
                    if (Object.keys(data.result).length === 1) bestAction = Object.keys(data.result)[0];
                    else {
                        bestAction = Object.keys(data.result)[0];
                        let bestConfidence = Number(data.result[Object.keys(data.result)[0]]);
                        for (let i = 1; i < Object.keys(data.result).length; i++) {
                            if (Number(data.result[Object.keys(data.result)[i]]) > bestConfidence) {
                                bestAction = Object.keys(data.result)[i];
                                bestConfidence = Number(data.result[Object.keys(data.result)[i]]);
                            }
                        }
                    }
                }
                if (autoPlay) {
                    proceedNextTurn(bestAction.split(''));
                }
            }
        } catch (err) {
            Message({
                message: 'Error receiving prediction result, please try refresh the page',
                type: 'error',
                showClose: true,
            });
        }
    };

    const isOriginalLandlordCardPlayed = (card) =>
        originalThreeLandlordCards.includes(card) && !remainingLandlordCards.includes(card);

    const openGameStatisticsDialog = (winnerRole) => {
        setHideRivalHand(false);
        const gameStatistics = localStorage.getItem('GAME_STATISTICS')
            ? JSON.parse(localStorage.getItem('GAME_STATISTICS'))
            : {
                  totalGameNum: 0,
                  totalWinNum: 0,
                  landlordGameNum: 0,
                  landlordWinNum: 0,
                  landlordUpGameNum: 0,
                  landlordUpWinNum: 0,
                  landlordDownGameNum: 0,
                  landlordDownWinNum: 0,
              };

        gameStatistics.totalGameNum += 1;
        switch (playerInfo[mainPlayerId].douzeroPlayerPosition) {
            case 0:
                gameStatistics.landlordGameNum += 1;
                if (winnerRole === playerInfo[mainPlayerId].role) {
                    gameStatistics.totalWinNum += 1;
                    gameStatistics.landlordWinNum += 1;
                }
                break;
            case 1:
                gameStatistics.landlordDownGameNum += 1;
                if (winnerRole === playerInfo[mainPlayerId].role) {
                    gameStatistics.totalWinNum += 1;
                    gameStatistics.landlordDownWinNum += 1;
                }
                break;
            case 2:
                gameStatistics.landlordUpGameNum += 1;
                if (winnerRole === playerInfo[mainPlayerId].role) {
                    gameStatistics.totalWinNum += 1;
                    gameStatistics.landlordUpWinNum += 1;
                }
                break;
            default:
                Message({
                    message: 'Wrong douzero player position',
                    type: 'error',
                    showClose: true,
                });
        }
        localStorage.setItem('GAME_STATISTICS', JSON.stringify(gameStatistics));

        gameEndDialogTitle =
            winnerRole === 'peasant' ? t('doudizhu.peasants_win') : t('doudizhu.landlord_win');
        setStatisticRows([
            {
                role: t('doudizhu.landlord'),
                win: gameStatistics.landlordWinNum,
                total: gameStatistics.landlordGameNum,
                winRate: gameStatistics.landlordGameNum
                    ? ((gameStatistics.landlordWinNum / gameStatistics.landlordGameNum) * 100).toFixed(2) + '%'
                    : '-',
            },
            {
                role: t('doudizhu.landlord_up'),
                win: gameStatistics.landlordUpWinNum,
                total: gameStatistics.landlordUpGameNum,
                winRate: gameStatistics.landlordUpGameNum
                    ? ((gameStatistics.landlordUpWinNum / gameStatistics.landlordUpGameNum) * 100).toFixed(2) + '%'
                    : '-',
            },
            {
                role: t('doudizhu.landlord_down'),
                win: gameStatistics.landlordDownWinNum,
                total: gameStatistics.landlordDownGameNum,
                winRate: gameStatistics.landlordDownGameNum
                    ? ((gameStatistics.landlordDownWinNum / gameStatistics.landlordDownGameNum) * 100).toFixed(2) +
                      '%'
                    : '-',
            },
            {
                role: 'All',
                win: gameStatistics.totalWinNum,
                total: gameStatistics.totalGameNum,
                winRate: gameStatistics.totalGameNum
                    ? ((gameStatistics.totalWinNum / gameStatistics.totalGameNum) * 100).toFixed(2) + '%'
                    : '-',
            },
        ]);
        setIsGameEndDialogOpen(true);
    };

    const handleOpenGameMenu = (event) => {
        setGameMenuAnchor(event.currentTarget);
    };

    const handleCloseGameMenu = () => {
        setGameMenuAnchor(null);
    };

    const resetSessionToReady = () => {
        if (gameStateTimeout) {
            clearTimeout(gameStateTimeout);
        }
        playerInfo = [];
        gameStateTimeout = null;
        gameHistory = [];
        bombNum = 0;
        lastMoveLandlord = [];
        lastMoveLandlordDown = [];
        lastMoveLandlordUp = [];
        playedCardsLandlord = [];
        playedCardsLandlordDown = [];
        playedCardsLandlordUp = [];
        legalActions = { turn: -1, actions: [] };

        setConsiderationTime(initConsiderationTime);
        setToggleFade('');
        setIsPassDisabled(true);
        setIsHintDisabled(true);
        setSelectedCards([]);
        setPredictionRes({ prediction: [], hands: [] });
        setShowPlayerRecommendations([false, false, false]);
        setPlayerWinRateHistory([[], [], []]);
        enterReadyWithPreview();
        setIsGameEndDialogOpen(false);
    };

    const handleOpenManualDeal = () => {
        handleCloseGameMenu();
        setIsManualDealOpen(true);
    };

    const handleConfirmManualDeal = ({ hands, landlordCards }) => {
        initHands = hands.map((hand) => hand.slice());
        threeLandlordCards = landlordCards.slice();
        originalThreeLandlordCards = threeLandlordCards.slice();
        setRemainingLandlordCards(threeLandlordCards.slice());
        setIsManualDealOpen(false);
        resetSessionToReady();
    };

    const handleNewGame = () => {
        handleCloseGameMenu();
        if (gameStateTimeout) {
            clearTimeout(gameStateTimeout);
        }
        handleCloseGameEndDialog();
    };

    const handleLandlordSurrender = () => {
        handleCloseGameMenu();
        if (gameStatus !== 'playing' || playerInfo[mainPlayerId]?.role !== 'landlord') {
            return;
        }
        if (gameStateTimeout) {
            clearTimeout(gameStateTimeout);
        }
        syncGameStatus = 'over';
        setGameStatus('over');
        openGameStatisticsDialog('peasant');
    };

    const isMainPlayerLandlord = playerInfo[mainPlayerId]?.role === 'landlord';

    const toggleHideRivalHand = () => {
        setHideRivalHand(!hideRivalHand);
    };

    const refreshPredictionsForCurrentState = (useOracle = oraclePredict) => {
        if (gameState.currentPlayer === null || gameStatus !== 'playing') {
            return;
        }
        refreshAllPlayersWinRates(gameState, gameState.turn, useOracle);
        requestApiPlay(gameState.currentPlayer !== mainPlayerId, useOracle);
    };

    const handleOraclePredictChange = (event, checked) => {
        event.stopPropagation();
        setOraclePredict(checked);
        localStorage.setItem('ORACLE_PREDICT', checked ? '1' : '0');
        refreshPredictionsForCurrentState(checked);
    };

    const handleCardCounterChange = (event, checked) => {
        event.stopPropagation();
        setShowCardCounter(checked);
        localStorage.setItem('CARD_COUNTER', checked ? '1' : '0');
    };

    const mainPlayerHandIdx = playerInfo.find((player) => player.id === mainPlayerId)?.index ?? 0;
    const cardCounterMyHand = gameState.hands[mainPlayerHandIdx] ?? [];
    const cardCounterPlayedCards = useMemo(
        () => [...playedCardsLandlord, ...playedCardsLandlordDown, ...playedCardsLandlordUp],
        [gameState.turn, gameStatus],
    );

    const toggleShowPlayerRecommendation = (playerIdx) => {
        setShowPlayerRecommendations((prev) => {
            const next = prev.slice();
            next[playerIdx] = !next[playerIdx];
            return next;
        });
    };

    const shouldShowCurrentPlayerRecommendations = () => {
        if (gameState.currentPlayer === null) {
            return false;
        }
        return showPlayerRecommendations[gameState.currentPlayer];
    };

    const selectCardsFromAction = (actionStr, hand) => {
        if (!actionStr) {
            return [];
        }
        const remaining = hand.slice();
        const picked = [];
        actionStr.split('').forEach((rank) => {
            const idx = remaining.findIndex((card) => card2SuiteAndRank(card).rank === rank);
            if (idx >= 0) {
                picked.push(remaining[idx]);
                remaining.splice(idx, 1);
            }
        });
        return picked;
    };

    const handlePlayRecommendation = (idx) => {
        if (gameState.currentPlayer !== mainPlayerId || gameStatus !== 'playing') {
            return;
        }
        if (!shouldShowCurrentPlayerRecommendations()) {
            return;
        }
        if (predictionRes.prediction.length <= idx) {
            return;
        }
        if (gameState.turn !== legalActions.turn) {
            Message({
                message: 'Legal Action not received or turn info inconsistant',
                type: 'error',
                showClose: true,
            });
            return;
        }

        const actionStr = predictionRes.prediction[idx][0];
        if (!actionStr) {
            proceedNextTurn([], false);
            setSelectedCards([]);
            return;
        }

        const cards = selectCardsFromAction(actionStr, gameState.hands[mainPlayerId]);
        const formattedAction = cardArr2DouzeroFormat(sortDoudizhuCards(cards, true));
        if (legalActions.actions.indexOf(formattedAction) >= 0) {
            proceedNextTurn(cards, false);
            setSelectedCards([]);
        } else {
            Message({
                message: 'Selected cards are not legal action',
                type: 'warning',
                showClose: true,
            });
        }
    };

    const canClickRecommendation = (idx) =>
        gameStatus === 'playing' &&
        gameState.currentPlayer === mainPlayerId &&
        shouldShowCurrentPlayerRecommendations() &&
        predictionRes.prediction.length > idx;

    const handleSelectedCards = (cards) => {
        let newSelectedCards = selectedCards.slice();
        cards.forEach((card) => {
            if (newSelectedCards.indexOf(card) >= 0) {
                newSelectedCards.splice(newSelectedCards.indexOf(card), 1);
            } else {
                newSelectedCards.push(card);
            }
        });
        setSelectedCards(newSelectedCards);
    };

    const handleSelectRole = (role) => {
        const playerInfoTemplate = [
            {
                id: 0,
                index: 0,
                role: 'peasant',
                douzeroPlayerPosition: -1,
            },
            {
                id: 1,
                index: 1,
                role: 'peasant',
                douzeroPlayerPosition: -1,
            },
            {
                id: 2,
                index: 2,
                role: 'peasant',
                douzeroPlayerPosition: -1,
            },
        ];
        switch (role) {
            case 'landlord_up':
                playerInfo = deepCopy(playerInfoTemplate);
                playerInfo[1].role = 'landlord';
                break;
            case 'landlord':
                playerInfo = deepCopy(playerInfoTemplate);
                playerInfo[0].role = 'landlord';
                break;
            case 'landlord_down':
                playerInfo = deepCopy(playerInfoTemplate);
                playerInfo[2].role = 'landlord';
                break;
            default:
                break;
        }
        const landlordIdx = playerInfo.find((player) => player.role === 'landlord').index;
        playerInfo[landlordIdx].douzeroPlayerPosition = 0;
        playerInfo[(landlordIdx + 1) % 3].douzeroPlayerPosition = 1;
        playerInfo[(landlordIdx + 2) % 3].douzeroPlayerPosition = 2;
        initHands[landlordIdx] = initHands[landlordIdx].concat(threeLandlordCards.slice());
        setGameStatus('playing');
        syncGameStatus = 'playing';
    };

    const gameStateTimer = () => {
        gameStateTimeout = setTimeout(() => {
            let currentConsiderationTime = considerationTime;
            if (currentConsiderationTime > 0) {
                currentConsiderationTime -= considerationTimeDeduction;
                currentConsiderationTime = Math.max(currentConsiderationTime, 0);
                setConsiderationTime(currentConsiderationTime);
            } else {
                // consideration time used up for current player
                // if current player is controlled by user, play a random card
                // todo
            }
        }, considerationTimeDeduction);
    };

    const handleResetStatistics = () => {
        localStorage.removeItem('GAME_STATISTICS');
        setStatisticRows([
            {
                role: t('doudizhu.landlord'),
                win: 0,
                total: 0,
                winRate: '-',
            },
            {
                role: t('doudizhu.landlord_up'),
                win: 0,
                total: 0,
                winRate: '-',
            },
            {
                role: t('doudizhu.landlord_down'),
                win: 0,
                total: 0,
                winRate: '-',
            },
            {
                role: 'All',
                win: 0,
                total: 0,
                winRate: '-',
            },
        ]);
    };

    const handleCloseGameEndDialog = () => {
        // reset all game state for new game
        shuffledDoudizhuDeck = shuffleArray(fullDoudizhuDeck.slice());

        threeLandlordCards = shuffleArray(sortDoudizhuCards(shuffledDoudizhuDeck.slice(0, 3)));
        originalThreeLandlordCards = threeLandlordCards.slice();
        setRemainingLandlordCards(threeLandlordCards.slice());

        initHands = [
            shuffledDoudizhuDeck.slice(3, 20),
            shuffledDoudizhuDeck.slice(20, 37),
            shuffledDoudizhuDeck.slice(37, 54),
        ];

        playerInfo = [];

        gameStateTimeout = null;
        gameHistory = [];
        bombNum = 0;
        lastMoveLandlord = [];
        lastMoveLandlordDown = [];
        lastMoveLandlordUp = [];
        playedCardsLandlord = [];
        playedCardsLandlordDown = [];
        playedCardsLandlordUp = [];
        legalActions = { turn: -1, actions: [] };

        setConsiderationTime(initConsiderationTime);
        setToggleFade('');
        setIsPassDisabled(true);
        setIsHintDisabled(true);
        setSelectedCards([]);
        setPredictionRes({ prediction: [], hands: [] });
        setShowPlayerRecommendations([false, false, false]);
        setPlayerWinRateHistory([[], [], []]);
        enterReadyWithPreview();
        setIsGameEndDialogOpen(false);
    };

    const startGame = async () => {
        // start game
        setGameStatus('playing');
        syncGameStatus = 'playing';
        const newGameState = deepCopy(gameState);
        // find landord to be the first player
        newGameState.currentPlayer = playerInfo.find((element) => element.role === 'landlord').index;
        newGameState.hands = initHands.map((element) => sortDoudizhuCards(element, true));

        // if first player is user, fetch legal actions
        if (newGameState.currentPlayer === mainPlayerId) {
            const player_hand_cards = cardArr2DouzeroFormat(newGameState.hands[mainPlayerId].slice().reverse());
            let rival_move = '';
            const requestBody = {
                player_hand_cards,
                rival_move,
            };
            const data = await douzeroLegal(requestBody);
            legalActions = {
                turn: 0,
                actions: data.legal_action.split(','),
            };
            setIsHintDisabled(data.legal_action === '');
        }

        setGameState(newGameState);
        gameStateTimer();
        setRemainingLandlordCards(threeLandlordCards.slice());
        refreshAllPlayersWinRates(newGameState, newGameState.turn);
    };

    useEffect(() => {
        if (syncGameStatus === 'playing') gameStateTimer();
    }, [considerationTime]);

    useEffect(() => {
        if (gameState.currentPlayer !== null && syncGameStatus === 'playing' && modelsReady) {
            if (gameState.currentPlayer !== mainPlayerId) {
                requestApiPlay(true);
            } else {
                requestApiPlay(false);
            }
        }
    }, [gameState.currentPlayer, modelsReady]);

    useEffect(() => {
        if (gameStatus === 'playing') startGame();
    }, [gameStatus]);

    const handleMainPlayerAct = (type) => {
        switch (type) {
            case 'play': {
                // check if cards to play is in legal action list
                if (gameState.turn === legalActions.turn) {
                    if (
                        legalActions.actions.indexOf(cardArr2DouzeroFormat(sortDoudizhuCards(selectedCards, true))) >= 0
                    ) {
                        proceedNextTurn(selectedCards, false);
                    } else {
                        Message({
                            message: 'Selected cards are not legal action',
                            type: 'warning',
                            showClose: true,
                        });
                        setSelectedCards([]);
                    }
                } else {
                    Message({
                        message: 'Legal Action not received or turn info inconsistant',
                        type: 'error',
                        showClose: true,
                    });
                }
                break;
            }
            case 'pass': {
                proceedNextTurn([], false);
                setSelectedCards([]);
                break;
            }
            case 'deselect': {
                setSelectedCards([]);
                break;
            }
            case 'hint': {
                if (gameState.turn === legalActions.turn) {
                    setSelectedCards([]);
                    hintIdx++;
                    if (hintIdx >= legalActions.actions.length) {
                        hintIdx = 0;
                    }
                    const hintRanks = legalActions.actions[hintIdx].split('');
                    let hintCards = [];
                    gameState.hands[gameState.currentPlayer].forEach((card) => {
                        const { rank } = card2SuiteAndRank(card);
                        const idx = hintRanks.indexOf(rank);
                        if (idx >= 0) {
                            hintRanks.splice(idx, 1);
                            hintCards.push(card);
                        }
                    });
                    setSelectedCards(hintCards);
                } else {
                    Message({
                        message: 'Legal Action not received or turn info inconsistant',
                        type: 'error',
                        showClose: true,
                    });
                }
                break;
            }
        }
    };

    const computePredictionCards = (cards, hands) => {
        let computedCards = [];
        if (cards.length > 0) {
            hands.forEach((card) => {
                const { rank } = card2SuiteAndRank(card);
                const idx = cards.indexOf(rank);
                if (idx >= 0) {
                    cards.splice(idx, 1);
                    computedCards.push(card);
                }
            });
        } else {
            computedCards = 'pass';
        }

        if (computedCards === 'pass') {
            return (
                <div className={'non-card ' + toggleFade}>
                    <span>{t('doudizhu.pass')}</span>
                </div>
            );
        } else {
            return (
                <div className={'unselectable playingCards loose ' + toggleFade}>
                    <ul className="hand" style={{ width: computeHandCardsWidth(computedCards.length, 10) }}>
                        {computedCards.map((card) => {
                            const [rankClass, suitClass, rankText, suitText] = translateCardData(card);
                            return (
                                <li key={`handCard-${card}`}>
                                    <label className={`card ${rankClass} ${suitClass}`} href="/#">
                                        <span className="rank">{rankText}</span>
                                        <span className="suit">{suitText}</span>
                                    </label>
                                </li>
                            );
                        })}
                    </ul>
                </div>
            );
        }
    };

    const computeProbabilityItem = (idx) => {
        if (gameStatus !== 'ready') {
            if (!shouldShowCurrentPlayerRecommendations()) {
                return (
                    <div className={'playing'}>
                        <div className={'non-card'}>
                            <span>{t('hidden')}</span>
                        </div>
                    </div>
                );
            }
            return (
                <div
                    className={`playing${canClickRecommendation(idx) ? ' recommendation-playable' : ''}`}
                    onClick={() => canClickRecommendation(idx) && handlePlayRecommendation(idx)}
                    onKeyDown={(event) => {
                        if (canClickRecommendation(idx) && (event.key === 'Enter' || event.key === ' ')) {
                            event.preventDefault();
                            handlePlayRecommendation(idx);
                        }
                    }}
                    role={canClickRecommendation(idx) ? 'button' : undefined}
                    tabIndex={canClickRecommendation(idx) ? 0 : undefined}
                >
                    <div className="probability-move">
                        {predictionRes.prediction.length > idx ? (
                            computePredictionCards(predictionRes.prediction[idx][0].split(''), predictionRes.hands)
                        ) : (
                            <NotInterestedIcon fontSize="large" />
                        )}
                    </div>
                    {predictionRes.prediction.length > idx ? (
                        <div className={'non-card'} style={{ marginTop: '0px' }}>
                            <span>{`${t('doudizhu.expected_win_rate')}: ${(
                                Number(predictionRes.prediction[idx][1]) * 100
                            ).toFixed(2)}%`}</span>
                        </div>
                    ) : (
                        ''
                    )}
                </div>
            );
        } else {
            return <span className={'waiting'}>{t('waiting...')}</span>;
        }
    };

    const gameSpeedMarks = [
        {
            value: 0,
            label: '0s',
        },
        {
            value: 1,
            label: '1s',
        },
        {
            value: 2,
            label: '3s',
        },
        {
            value: 3,
            label: '5s',
        },
        {
            value: 4,
            label: '10s',
        },
        {
            value: 5,
            label: '30s',
        },
    ];

    const gameSpeedMap = [
        {
            value: 0,
            delay: 0,
        },
        {
            value: 1,
            delay: 1000,
        },
        {
            value: 2,
            delay: 3000,
        },
        {
            value: 3,
            delay: 5000,
        },
        {
            value: 4,
            delay: 10000,
        },
        {
            value: 5,
            delay: 30000,
        },
    ];

    const changeApiPlayerDelay = (newVal) => {
        const found = gameSpeedMap.find((element) => element.value === newVal);
        if (found) setApiPlayDelay(found.delay);
    };

    const sliderValueText = (value) => {
        return value;
    };

    const handleLocaleChange = useCallback((newLocale) => {
        i18n.changeLanguage(newLocale);
        setLocale(newLocale);
        localStorage.setItem('LOCALE', newLocale);
    }, []);

    return (
        <div>
            <Dialog
                disableBackdropClick
                open={isGameEndDialogOpen}
                onClose={handleCloseGameEndDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title" style={{ width: '200px' }}>
                    {gameEndDialogTitle}
                </DialogTitle>
                <DialogContent>
                    <TableContainer className="doudizhu-statistic-table" component={Paper}>
                        <Table aria-label="statistic table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('doudizhu.role')}</TableCell>
                                    <TableCell>{t('doudizhu.win')}</TableCell>
                                    <TableCell>{t('doudizhu.total')}</TableCell>
                                    <TableCell>{t('doudizhu.win_rate')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {statisticRows.map((row) => (
                                    <TableRow key={'statistic-row-' + row.role}>
                                        <TableCell component="th" scope="row">
                                            {row.role}
                                        </TableCell>
                                        <TableCell>{row.win}</TableCell>
                                        <TableCell>{row.total}</TableCell>
                                        <TableCell>{row.winRate}</TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleResetStatistics()}>{t('reset')}</Button>
                    <Button
                        onClick={() => handleCloseGameEndDialog()}
                        color="primary"
                        variant="contained"
                        autoFocus
                        style={{ margin: '16px' }}
                    >
                        {t('play_again')}
                    </Button>
                </DialogActions>
            </Dialog>
            <ManualDealDialog
                open={isManualDealOpen}
                onClose={() => setIsManualDealOpen(false)}
                onConfirm={handleConfirmManualDeal}
            />
            <div className={'doudizhu-view-container'}>
                {modelsLoading ? (
                    <div className="doudizhu-models-loading">{t('doudizhu.models_loading')}</div>
                ) : null}
                <Layout.Row style={{ height: '540px' }}>
                    <Layout.Col style={{ height: '100%' }} span="17">
                        <div style={{ height: '100%' }}>
                            <Paper className={'doudizhu-gameboard-paper'} elevation={3}>
                                <DoudizhuGameBoard
                                    key={previewTick}
                                    showCardBack={
                                        gameStatus === 'ready' ||
                                        (gameStatus === 'playing' && hideRivalHand)
                                    }
                                    handleSelectRole={handleSelectRole}
                                    isPassDisabled={isPassDisabled}
                                    isHintDisabled={isHintDisabled}
                                    gamePlayable={gameStatus === 'playing'}
                                    playerInfo={playerInfo}
                                    hands={gameState.hands}
                                    selectedCards={selectedCards}
                                    handleSelectedCards={handleSelectedCards}
                                    latestAction={gameState.latestAction}
                                    mainPlayerId={mainPlayerId}
                                    currentPlayer={gameState.currentPlayer}
                                    considerationTime={considerationTime}
                                    turn={gameState.turn}
                                    toggleFade={toggleFade}
                                    gameStatus={gameStatus}
                                    handleMainPlayerAct={handleMainPlayerAct}
                                    handleLocaleChange={(newLocale) => {
                                        handleLocaleChange(newLocale);
                                        enterReadyWithPreview();
                                    }}
                                />
                            </Paper>
                        </div>
                    </Layout.Col>
                    <Layout.Col span="7" style={{ height: '100%' }}>
                        <Paper className={'doudizhu-probability-paper'} elevation={3}>
                            {playerInfo.length > 0 && gameState.currentPlayer !== null ? (
                                <div style={{ padding: '16px' }}>
                                    <span style={{ textAlign: 'center', marginBottom: '8px', display: 'block' }}>
                                        {t('doudizhu.three_landlord_cards')}
                                    </span>
                                    <div className="playingCards" style={{ display: 'flex', justifyContent: 'center' }}>
                                        {sortDoudizhuCards(originalThreeLandlordCards, true).map((card) => {
                                            const [rankClass, suitClass, rankText, suitText] = translateCardData(card);
                                            const played = isOriginalLandlordCardPlayed(card);
                                            return (
                                                <div
                                                    key={'probability-cards-' + rankText + '-' + suitText}
                                                    style={{ fontSize: '1.2em' }}
                                                    className={`card ${rankClass} full-content ${suitClass}${
                                                        played ? ' landlord-card-played' : ''
                                                    }`}
                                                >
                                                    <span className="rank">{rankText}</span>
                                                    <span className="suit">{suitText}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            ) : gameStatus === 'ready' ? (
                                <div
                                    style={{
                                        height: '112px',
                                        padding: '16px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <span>{t('doudizhu.preview_landlord_hidden')}</span>
                                </div>
                            ) : (
                                <div
                                    style={{
                                        height: '112px',
                                        padding: '16px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <span>{t('waiting...')}</span>
                                </div>
                            )}
                            <Divider />
                            <div className={'probability-player'} style={{ height: '19px', textAlign: 'center' }}>
                                {gameStatus === 'ready' ? (
                                    <span>{t('doudizhu.preview_choose_role')}</span>
                                ) : playerInfo.length > 0 && gameState.currentPlayer !== null ? (
                                    <span>
                                        {t(
                                            `doudizhu.${
                                                ['landlord', 'landlord_down', 'landlord_up'][
                                                    playerInfo[gameState.currentPlayer].douzeroPlayerPosition
                                                ]
                                            }`,
                                        )}
                                    </span>
                                ) : (
                                    <span>{t('waiting...')}</span>
                                )}
                            </div>
                            <Divider />
                            <div className={'probability-table with-three-landlord-cards'}>
                                <div className={'probability-item'}>{computeProbabilityItem(0)}</div>
                                <div className={'probability-item'}>{computeProbabilityItem(1)}</div>
                                <div className={'probability-item'}>{computeProbabilityItem(2)}</div>
                            </div>
                        </Paper>
                    </Layout.Col>
                </Layout.Row>
                {[0, 1, 2].map((playerIdx) => (
                    <Layout.Row key={`win-rate-row-${playerIdx}`} className="doudizhu-win-rate-row">
                        <Layout.Col span="24">
                            <Paper className="doudizhu-player-win-rate-paper" elevation={3}>
                                <div className="doudizhu-player-win-rate-header">
                                    <FormControlLabel
                                        className="doudizhu-player-win-rate-toggle"
                                        control={
                                            <Switch
                                                size="small"
                                                checked={showPlayerRecommendations[playerIdx]}
                                                onChange={() => toggleShowPlayerRecommendation(playerIdx)}
                                            />
                                        }
                                        label={t('doudizhu.show_recommendations_for', { id: playerIdx })}
                                    />
                                    <div className="doudizhu-player-win-rate-title">
                                        {t('doudizhu.player_win_rate_trend', { id: playerIdx })}
                                    </div>
                                </div>
                                <WinRateTrendChart
                                    points={playerWinRateHistory[playerIdx]}
                                    visible={showPlayerRecommendations[playerIdx]}
                                    hiddenLabel={t('hidden')}
                                    emptyLabel={t('doudizhu.win_rate_trend_empty')}
                                />
                            </Paper>
                        </Layout.Col>
                    </Layout.Row>
                ))}
                <div className="game-controller">
                    <Paper className={'game-controller-paper'} elevation={3}>
                        <div className="game-controller-toolbar">
                            <div className="game-controller-menu">
                                <IconButton
                                    aria-label={t('doudizhu.game_menu')}
                                    onClick={handleOpenGameMenu}
                                    size="small"
                                >
                                    <MenuIcon />
                                </IconButton>
                                <Menu
                                    anchorEl={gameMenuAnchor}
                                    open={Boolean(gameMenuAnchor)}
                                    onClose={handleCloseGameMenu}
                                    keepMounted
                                >
                                    <MenuItem onClick={handleNewGame}>{t('doudizhu.new_game')}</MenuItem>
                                    <MenuItem onClick={handleOpenManualDeal}>{t('doudizhu.manual_deal')}</MenuItem>
                                    {isMainPlayerLandlord && gameStatus === 'playing' ? (
                                        <MenuItem onClick={handleLandlordSurrender}>{t('doudizhu.surrender')}</MenuItem>
                                    ) : null}
                                    <MenuItem onClick={(event) => event.stopPropagation()}>
                                        <FormControlLabel
                                            className="game-menu-switch"
                                            control={
                                                <Switch
                                                    size="small"
                                                    checked={oraclePredict}
                                                    onChange={handleOraclePredictChange}
                                                    onClick={(event) => event.stopPropagation()}
                                                />
                                            }
                                            label={t('doudizhu.oracle_predict')}
                                            onClick={(event) => event.stopPropagation()}
                                        />
                                    </MenuItem>
                                    <MenuItem onClick={(event) => event.stopPropagation()}>
                                        <FormControlLabel
                                            className="game-menu-switch"
                                            control={
                                                <Switch
                                                    size="small"
                                                    checked={showCardCounter}
                                                    onChange={handleCardCounterChange}
                                                    onClick={(event) => event.stopPropagation()}
                                                />
                                            }
                                            label={t('doudizhu.card_counter')}
                                            onClick={(event) => event.stopPropagation()}
                                        />
                                    </MenuItem>
                                </Menu>
                            </div>
                            <Divider className="game-controller-divider" orientation="vertical" flexItem />
                            <FormControlLabel
                                className="switch-control switch-control--compact"
                                control={
                                    <Switch
                                        size="small"
                                        checked={!hideRivalHand}
                                        onChange={toggleHideRivalHand}
                                    />
                                }
                                label={t('doudizhu.ai_hand_faceup')}
                            />
                            <Divider className="game-controller-divider" orientation="vertical" flexItem />
                            <div className="game-controller-turn">{`${t('turn')} ${gameState.turn}`}</div>
                            <Divider className="game-controller-divider" orientation="vertical" flexItem />
                            <div className="game-controller-slider">
                                <label className="game-controller-slider-label">{t('doudizhu.ai_thinking_time')}</label>
                                <Slider
                                    value={gameSpeedMap.find((element) => element.delay === apiPlayDelay).value}
                                    getAriaValueText={sliderValueText}
                                    onChange={(e, newVal) => {
                                        changeApiPlayerDelay(newVal);
                                    }}
                                    aria-labelledby="discrete-slider-custom"
                                    step={1}
                                    min={0}
                                    max={5}
                                    track={false}
                                    valueLabelDisplay="off"
                                    marks={gameSpeedMarks}
                                />
                            </div>
                            <Divider className="game-controller-divider" orientation="vertical" flexItem />
                            <div className="game-controller-locale">
                                <TranslateIcon className="game-controller-locale-icon" />
                                <Select
                                    id="language-select"
                                    className="game-controller-locale-select"
                                    value={locale}
                                    onChange={(e) => handleLocaleChange(e.target.value)}
                                >
                                    <MenuItem value={'zh'}>中文</MenuItem>
                                    <MenuItem value={'en'}>English</MenuItem>
                                </Select>
                            </div>
                        </div>
                    </Paper>
                </div>
                {showCardCounter && (gameStatus === 'ready' || gameStatus === 'playing') ? (
                    <Paper className="doudizhu-card-counter-paper" elevation={3}>
                        <CardCounter myHandCards={cardCounterMyHand} playedCards={cardCounterPlayedCards} />
                    </Paper>
                ) : null}
            </div>
        </div>
    );
}

export default PvEDoudizhuDemoView;
